<template>
  <div class="wrapper d-flex flex-column min-vh-100 bg-body">
    <main v-show="!pageLoadingStatus" class="container-fluid py-3">
      <router-view />
    </main>
  </div>
</template>

<script>

export default {
  name: 'SimpleLayout',
  computed: {
    pageLoadingStatus() {
      return this.$store.state.pageLoading;
    },
  },
}
</script>
